import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatUGX(amount: number): string {
  return 'UGX ' + Math.round(amount).toLocaleString('en-UG');
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-UG', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

export function formatPhone(phone: string): string {
  // +256XXXXXXXXX → 0XX XXX XXXX
  return phone.replace('+256', '0').replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
}

export function initials(firstName: string, lastName: string): string {
  return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();
}
